const toProfileState = profile => {
  const permissoes = profile.permissoes.reduce((previous, current) => {
    const { funcionalidade, ler, editar, remover } = current
    const { _id, alias } = funcionalidade

    return {
      ...previous,
      [alias]: {
        funcionalidade: _id,
        ler,
        editar,
        remover
      }
    }
  }, {})

  return {
    ...profile,
    permissoes
  }
}

module.exports = {
  toProfileState
}



// WEBPACK FOOTER //
// ./src/utils/handleProfileApiData.js